import { handleActions } from 'redux-actions';
import u from 'updeep';
import * as actions from './stemActions';

const initialState = {
  isFetchingAllLP: false,
  lessonPlans: [],
  isFetchingLP: false,
  lpData: null,
  isFetchingLpStaticData: false,
  lpStaticData: null,
  isFetchingSkillSet: false,
  skillSetData: null,
  isFetchingStemStaticData: false,
  stemStaticData: null,
  isFetchingBookmark: false,
  bookmarks: [],
  isFetchingLpBooks: false,
  lpBooks: [],
  isFetchingLpArray: false,
  lpArray: [],
  isBookMarked: false,
  isBookmarking: false,
  activeLp: null,
  isFetchingReco: false,
  recommended: [],
  isFetchingStemLiteracyStaticData: false,
  StemLiteracyStaticData: null,
  isFetchingAllCampaignsData: false,
  allCampaignsData: [],
  isFetchingAllProgramCampaignsData: false,
  allProgramCampaignsData: [],
  isFetchingIndCampaignsData: false,
  indCampaignsData: {},
  isFetchingAllPressReleaseData: false,
  allPressReleaseData: [],
  pressPagination: {},
  isFetchingIndPressReleaseData: false,
  indPressReleaseData: {},
  moocData: {},
  moocModuleData: {},
  isStemEnrolling: false,
  isStemEnrolled: false,
  videoSet: false,
  videosViewed: [],
  showSuccessAnimation: false,
  storiesData: null,
  stemExploreStaticData: {},
  groupingStaticData: {},
  isFetchingAllNewsData: false,
  allNewsData: [],
  newsPagination: {},
  indNewsData: [],
  isFetchingIndNewsData: false,
  flpMoocData: {},
  flpMoocModuleData: {},
  isFlpMoocEnrolling: false,
  isFlpMoocEnrolled: false,
  showFlpMoocSuccessAnimation: false,
  flpMoocVideosViewed: [],
  isPledgeEnrolling: false,
  isPledgeEnrolled: false,
  isFetchingPledgeStatus: false,
  isFetchingStaticPledgeData: false,
  staticPledgeData: {},
  gcrId: null,
  isFetchingStaticPartnereData: false,
  staticPartnerData: {},
  pledgeData: {},
  pledgeStats: {},
  heroActivity: null,
  flagshipVideos: null,
  stemEnrollment: {},
  isStemMoocCertDownloading: false,
  stemMoocAllModules: [],
  flpMoocAllModules: [],
  flpMoocEnrollment: {},
  isFlpMoocCertDownloading: false,
  isPartnerFormSubmiting: false,
  ptrPartnerDetails: {},
  stemSearchLps: [],
  stemSearchLpsCount: 0,
  tagStaticData: {},
  isFetchingSearchData: false,
  stemSearchData: {},
  ptrUserDetails: {},
  isGcrReadingCertDownloading: false,
  indNewsCardData: {},
  staticSubGcrData: [],
  impactStaticData: {},
  awardsStaticData:[],
  isFetchingAllImpactsData: false,
  allImpactsData: [],
  isFetchingOdosStatus: false,
  isOdosEnrolled: false,
  isOdosEnrolling: false,
  isOdosUserDetailsSubmiting: false,
  isOdosCertDownloading: false,
  odosUserDetails: {},
  odosEnrollmentDetails: {},
  isFetchingOldGcrPledgeData: false,
  oldGcrPledgeData: {},
  isFetchingOdosCertData: false,
  OdosCertData: {},
  odosErrorMsg: null,
  odosCertUrl: null,
  careerHomeStaticData: [],
  careerDetailStaticData: [],
  isIndCareerLoading: false,
  isResourcesLandingPageLoading: false,
  resourcesLandingPageData: {},
  isResourceStoriesLoading: false,
  resourceStories: [],
  isResourceStoriesLanguagesLoading: false,
  resourceStoriesLanguages: [],
  isFetchingAllCampaignRegistrations: false,
  allCampaignRegistrations: [],
  isFetchingECStaticData: false,
  eventCertificateStaticData: {},
  isEventCertEnrolling: false,
  isEventCertEnrolled: false,
  isFetchingEventCertDetails: false,
  eventCertDetails: {},
  isEventCertDownloading: false,
  eventCertUrl: null,
  isFetchingLangSupportData: false,
  eventLangSupportData: [],
  isImageAnalyze: false,
}

export default handleActions({

  [actions.fetchLessonPlans]: (state, action) => u({
    isFetchingAllLP: true,
  }, state),

  [actions.receiveLessonPlans]: (state, action) => u({
    isFetchingAllLP: false,
    lessonPlans: action.payload.data,
  }, state),

  [actions.fetchLessonPlansWithTag]: (state, action) => u({
    isFetchingAllLP: true,
  }, state),

  [actions.receiveLessonPlansWithTag]: (state, action) => u({
    isFetchingAllLP: false,
    lessonPlans: action.payload.data,
  }, state),

  [actions.fetchStemTagStaticData]: (state, action) => u({
    isFetchingLpStaticData: true,
  }, state),

  [actions.receiveStemTagStaticData]: (state, action) => u({
    isFetchingLpStaticData: false,
    tagStaticData: action.payload.data,
  }, state),

  [actions.fetchLessonPlanData]: (state, action) => u({
    isFetchingLP: true,
  }, state),

  [actions.receiveLessonPlanData]: (state, action) => u({
    isFetchingLP: false,
    lpData: action.payload.data,
  }, state),

  [actions.fetchLpStaticData]: (state, action) => u({
    isFetchingLpStaticData: true,
  }, state),

  [actions.receiveLpStaticData]: (state, action) => u({
    isFetchingLpStaticData: false,
    lpStaticData: action.payload.data.attributes,
  }, state),

  [actions.fetchLpFromSkillSet]: (state, action) => u({
    isFetchingSkillSet: true,
    skillSetData: null
  }, state),

  [actions.receiveLpFromSkillSet]: (state, action) => u({
    isFetchingSkillSet: false,
    skillSetData: Object.keys(action.payload.data).length > 0 ? action.payload.data : null,
  }, state),

  [actions.fetchLpFromBookId]: (state, action) => u({
    isFetchingLpArray: true,
  }, state),

  [actions.receiveLpFromBookId]: (state, action) => u({
      isFetchingLpArray: false,
      lpArray: action.payload.data,
    }, state),

  [actions.fetchBooksForLp]: (state, action) => u({
    isFetchingLpBooks: true,
  }, state),

  [actions.receiveBooksForLp]: (state, action) => u({
    isFetchingLpBooks: false,
    lpBooks: action.payload.data.stories,
  }, state),

  [actions.fetchStemStaticData]: (state, action) => u({
    isFetchingStemStaticData: true,
  }, state),

  [actions.receiveStemStaticData]: (state, action) => u({
    isFetchingStemStaticData: false,
    stemStaticData: action.payload.data,
  }, state),

  [actions.fetchStemTagSearchData]: (state, action) => u({
    isFetchingSearchData: true,
  }, state),

  [actions.receiveStemTagSearchData]: (state, action) => u({
    isFetchingSearchData: false,
    stemSearchData: action.payload.data,
  }, state),

  [actions.fetchBookMarks]: (state, action) => u({
    isFetchingBookmark: true,
  }, state),

  [actions.receiveBookMarks]: (state, action) => u({
    isFetchingBookmark: false,
    bookmarks: action.payload.bookmarks,
  }, state),

  [actions.fetchRecommended]: (state, action) => u({
    isFetchingReco: true,
  }, state),

  [actions.receiveRecommended]: (state, action) => u({
    isFetchingReco: false,
    recommended: action.payload.data,
  }, state),

  [actions.fetchAddBookMark]: (state, action) => u({
    isBookmarking: true,
    activeLp: action.payload.id
  }, state),

  [actions.receiveAddBookMark]: (state, action) => u({
    isBookmarking: false,
    isBookMarked: true,
  }, state),

  [actions.fetchDeleteBookMark]: (state, action) => u({
    isBookmarking: true,
    activeLp: action.payload.id
  }, state),

  [actions.receiveDeleteBookMark]: (state, action) => u({
    isBookmarking: false,
    isBookMarked: false,
  }, state),

  [actions.fetchStemLiteracyStaticData]: (state, action) => u({
    isFetchingStemStaticData: true,
  }, state),

  [actions.receiveStemLiteracyStaticData]: (state, action) => u({
    isFetchingStemLiteracyStaticData: false,
    StemLiteracyStaticData: action.payload.data.attributes,
  }, state),  

  [actions.receiveStemMoocData]: (state, action) => u({
    moocData: action.payload.data.attributes,
  }, state),

  [actions.receiveStemMoocModuleData]: (state, action) => u({
      moocModuleData: action.payload.data.attributes,
    }, state),
    
  [actions.receiveStemGroupingStaticData]: (state, action) => u({
    groupingStaticData: action.payload.data.attributes,
  }, state),

  [actions.fetchAllNewsData]: (state, action) => u({
    isFetchingAllNewsData: true,
  }, state),

  [actions.receiveAllNewsData]: (state, action) => u({
    isFetchingAllNewsData: false,
    allNewsData: action.payload.data,
    newsPagination: action.payload.meta.pagination
  }, state),  

  [actions.fetchIndNewsData]: (state, action) => u({
    isFetchingIndNewsData: true,
  }, state),

  [actions.receiveIndNewsData]: (state, action) => u({
    isFetchingIndNewsData: false,
    indNewsData: action.payload.data[0].attributes.newsSubCard,
    indNewsCardData: action.payload.data[0].attributes.indvNewsPage
  }, state),

  [actions.fetchStemExploreStaticData]: (state, action) => u({
    isFetchingStemExploreStaticData: true,
  }, state),

  [actions.receiveStemExploreStaticData]: (state, action) => u({
    isFetchingStemExploreStaticData: false,
    stemExploreStaticData: action.payload.data,
  }, state), 

  [actions.fetchGetStoriesStaticData]: (state, action) => u({
    isFetchingGetStoriesStaticData: true,
  }, state),

  [actions.receiveGetStoriesStaticData]: (state, action) => u({
    isFetchingGetStoriesStaticData: false,
    storiesData: action.payload.data[0],
  }, state), 

  [actions.fetchAllCampaignsData]: (state, action) => u({
    isFetchingAllCampaignsData: true,
  }, state),

  [actions.receiveAllCampaignsData]: (state, action) => u({
    isFetchingAllCampaignsData: false,
    allCampaignsData: action.payload.data,
  }, state),  

  [actions.fetchAllProgramCampaignsData]: (state, action) => u({
    isFetchingAllProgramCampaignsData: true,
  }, state),

  [actions.receiveAllProgramCampaignsData]: (state, action) => u({
    isFetchingAllProgramCampaignsData: false,
    allProgramCampaignsData: action.payload.data,
  }, state), 

  [actions.fetchAllImpactsData]: (state, action) => u({
    isFetchingAllImpactsData: true,
  }, state),

  [actions.receiveAllImpactsData]: (state, action) => u({
    isFetchingAllImpactsData: false,
    allImpactsData: action.payload.data,
  }, state), 

  [actions.fetchIndCampaignsData]: (state, action) => u({
    isFetchingIndCampaignsData: true,
  }, state),

  [actions.receiveIndCampaignsData]: (state, action) => u({
    isFetchingIndCampaignsData: false,
    indCampaignsData: action.payload.data[0].attributes,
  }, state),

  [actions.fetchIndProgramCampaignsData]: (state, action) => u({
    isFetchingIndCampaignsData: true,
  }, state),

  [actions.receiveIndProgramCampaignsData]: (state, action) => u({
    isFetchingIndCampaignsData: false,
    indCampaignsData: action.payload.data.length > 0 ? action.payload.data[0].attributes : {},
  }, state),

  [actions.fetchAllPressReleaseData]: (state, action) => u({
    isFetchingAllPressReleaseData: true,
  }, state),

  [actions.receiveAllPressReleaseData]: (state, action) => u({
    isFetchingAllPressReleaseData: false,
    allPressReleaseData: action.payload.data,
    pressPagination: action.payload.meta.pagination
  }, state),  

  [actions.fetchIndPressReleaseData]: (state, action) => u({
    isFetchingIndPressReleaseData: true,
  }, state),

  [actions.receiveIndPressReleaseData]: (state, action) => u({
    isFetchingIndPressReleaseData: false,
    indPressReleaseData: action.payload.data[0].attributes,
  }, state),

  [actions.fetchEnrolStemUser]: (state, action) => u({
    isStemEnrolling: true,
    showSuccessAnimation: false,
  }, state),

  [actions.receiveEnrolStemUser]: (state, action) => u({
    isStemEnrolling: false,
    isStemEnrolled: action.payload.ok,
    showSuccessAnimation: true
  }, state),

  [actions.fetchSetVideoView]: (state, action) => u({
    videoSet: false
  }, state),

  [actions.receiveSetVideoView]: (state, action) => u({
    videoSet: action.payload.ok
  }, state),

  [actions.fetchStemEnrolData]: (state, action) => u({
    isStemEnrolling: true,
  }, state),

  [actions.receiveStemEnrolData]: (state, action) => u({
    isStemEnrolling: false,
    isStemEnrolled: action.payload.ok,
    videosViewed: action.payload.ok ? action.payload.data.view_counts : [],
    stemEnrollment: action.payload.ok ? action.payload.data.stem_enrollment: null
  }, state),

  [actions.fetchStemEnrolDataError]: (state, action) => u({
    isStemEnrolling: false,
  }, state),

  [actions.fetchEnrollPledgeCampaign] : (state, action) => u({
    isPledgeEnrolling: true,
    showSuccessAnimation: false
  }, state),

  [actions.receiveEnrollPledgeCampaign] : (state, action) => u({
    isPledgeEnrolling: false,
    showSuccessAnimation: true
  }, state),

  [actions.receiveFlpMoocData]: (state, action) => u({
    flpMoocData: action.payload.data.attributes,
  }, state),

  [actions.receiveFlpMoocModuleData]: (state, action) => u({
    flpMoocModuleData: action.payload.data.attributes,
  }, state),

  [actions.fetchEnrolFlpMoocUser]: (state, action) => u({
    isFlpMoocEnrolling: true,
    showFlpMoocSuccessAnimation: false,
  }, state),

  [actions.receiveEnrolFlpMoocUser]: (state, action) => u({
    isFlpMoocEnrolling: false,
    isFlpMoocEnrolled: action.payload.ok,
    showFlpMoocSuccessAnimation: true
  }, state),

  [actions.fetchFlpMoocEnrolData]: (state, action) => u({
    isFlpMoocEnrolling: true,
  }, state),

  [actions.receiveFlpMoocEnrolData]: (state, action) => u({
    isFlpMoocEnrolling: false,
    isFlpMoocEnrolled: action.payload.ok,
    flpMoocVideosViewed: action.payload.data.view_counts,
    flpMoocEnrollment: action.payload.ok ? action.payload.data.flp_mooc_enrollment: null
  }, state),
  
  [actions.fetchFlpMoocEnrolDataError]: (state, action) => u({
    isFlpMoocEnrolling: false,
  }, state),

  [actions.fetchGetPledgeEnroll] : (state, action) => u({
    isFetchingPledgeStatus: true,
  }, state),

  [actions.receiveGetPledgeEnroll] : (state, action) => u({
    isFetchingPledgeStatus: false,
    isPledgeEnrolled: action.payload.ok,
    pledgeData: action.payload.pledge_to_read_data,
    pledgeStats: action.payload.stats,
    ptrPartnerDetails: action.payload.ptr_partner_details,
    ptrUserDetails: action.payload.ptr_user_details
  }, state),
  
  [actions.fetchStaticPledgeData] : (state, action) => u({
    isFetchingStaticPledgeData: true
  }, state),

  [actions.receiveStaticPledgeData] : (state, action) => u({
    isFetchingStaticPledgeData: false,
    staticPledgeData: action.payload.data.attributes
  }, state),

  [actions.fetchStaticSubCampaignData] : (state, action) => u({
    isFetchingStaticPledgeData: true
  }, state),

  [actions.receiveStaticSubCampaignData] : (state, action) => u({
    isFetchingStaticPledgeData: false,
    staticPledgeData: action.payload.data[0].attributes,
    gcrId: action.payload.data[0].id
  }, state),

  [actions.fetchStaticPledgePartnerData] : (state, action) => u({
    isFetchingStaticPartnerData: true
  }, state),

  [actions.receiveStaticPledgePartnerData] : (state, action) => u({
    isFetchingStaticPartnerData: false,
    staticPartnerData: action.payload.data.attributes
  }, state),

  [actions.fetchHeroActivity] : (state, action) => u({
    heroActivity: null
  }, state),

  [actions.receiveHeroActivity] : (state, action) => u({
    heroActivity: action.payload.org ? action.payload.data[0].attributes : action.payload.data.attributes
  }, state),

  [actions.receiveFlagshipVideos] : (state, action) => u({
    flagshipVideos: action.payload.data.attributes
  }, state),

  [actions.fetchStemMoocCertDownload]: (state, action) => u({
    isStemMoocCertDownloading: true,
  }, state),

  [actions.recieveStemMoocCertDownload]: (state, action) => u({
    isStemMoocCertDownloading: false,
  }, state),

  [actions.receiveStemMoocAllModules]: (state, action) => u({
    stemMoocAllModules: action.payload.data.attributes.module,
  }, state),

  [actions.receiveFlpMoocAllModules]: (state, action) => u({
    flpMoocAllModules: action.payload.data.attributes.flpModule,
  }, state),

  [actions.fetchFlpMoocCertDownload]: (state, action) => u({
    isFlpMoocCertDownloading: true,
  }, state),

  [actions.recieveFlpMoocCertDownload]: (state, action) => u({
    isFlpMoocCertDownloading: false,
  }, state),

  [actions.fetchPartnerPtrForm]: (state, action) => u({
    isPartnerFormSubmiting: true,
  }, state),

  [actions.receivePartnerPtrForm]: (state, action) => u({
    isPartnerFormSubmiting: false,
  }, state),
  
  [actions.receiveStemSearchResults]: (state, action) => u({
    stemSearchLps: action.payload.data,
    stemSearchLpsCount: action.payload.hits
  }, state),

  [actions.fetchGcrReadingCertificate]: (state, action) => u({
    isGcrReadingCertDownloading: true,
  }, state),

  [actions.receiveGcrReadingCertificate]: (state, action) => u({
    isGcrReadingCertDownloading: false,
  }, state),

  [actions.receiveStaticSubGcrData]: (state, action) => u({
    staticSubGcrData: action.payload.data,
  }, state),

  [actions.receiveGetImpactStaticData]: (state, action) => u({
    impactStaticData: action.payload.data[0].attributes,
  }, state),

  [actions.receiveGetAwardsStaticData]: (state, action) => u({
    awardsStaticData: action.payload.data,
  }, state),

  [actions.fetchGetOdosEnroll] : (state, action) => u({
    isFetchingOdosStatus: true,
  }, state),

  [actions.receiveGetOdosEnroll] : (state, action) => u({
    isFetchingOdosStatus: false,
    isOdosEnrolled: action.payload.ok,
    odosEnrollmentDetails: action.payload.odos_enrollment_details,
    odosUserDetails: action.payload.odos_user_details
  }, state),

  [actions.fetchEnrollOdosCampaign] : (state, action) => u({
    isOdosEnrolling: true,
    showSuccessAnimation: false
  }, state),

  [actions.receiveEnrollOdosCampaign] : (state, action) => u({
    isOdosEnrolling: false,
    showSuccessAnimation: true,
    odosEnrollmentDetails: action.payload.odos_data,
  }, state),

  [actions.fetchOdosUserDetails]: (state, action) => u({
    isOdosUserDetailsSubmiting: true,
  }, state),

  [actions.receiveOdosUserDetails]: (state, action) => u({
    isOdosUserDetailsSubmiting: false,
    odosErrorMsg: action.payload.message
  }, state),
  
  [actions.fetchOdosUserDetailsError]: (state, action) => u({
    isOdosUserDetailsSubmiting: false
  } , state),

  [actions.fetchOdosCertificate]: (state, action) => u({
    isOdosCertDownloading: true,
  }, state),

  [actions.receiveOdosCertificate]: (state, action) => u({
    isOdosCertDownloading: false,
    odosCertUrl: action.payload.url
  }, state),

  [actions.fetchImageAnalyze]: (state, action) => u({
    isImageAnalyze: true,
  }, state),

  [actions.receiveImageAnalyze]: (state, action) => u({
    isImageAnalyze: false,
  }, state),

  [actions.fetchOldGcrPledgeData] : (state, action) => u({
    isFetchingOldGcrPledgeData: true
  }, state),

  [actions.receiveOldGcrPledgeData] : (state, action) => u({
    isFetchingOldGcrPledgeData: false,
    oldGcrPledgeData: action.payload.data.attributes
  }, state),

  [actions.fetchOdosCertData] : (state, action) => u({
    isFetchingOdosCertData: true
  }, state),

  [actions.receiveOdosCertData] : (state, action) => u({
    isFetchingOdosCertData: false,
    OdosCertData: action.payload.data.attributes
  }, state),

  [actions.receiveGetCareerHomePageStaticData]: (state, action) => u({
    careerHomeStaticData: action.payload.data
  }, state),

  [actions.fetchGetCareerDetailPageStaticData]: (state, action) => u({
    isIndCareerLoading: true,
  }, state),

  [actions.receiveGetCareerDetailPageStaticData]: (state, action) => u({
    isIndCareerLoading: false,
    careerDetailStaticData: action.payload.data,
  }, state),

  [actions.fetchResourcesLandingPageData]: (state, action) => u({
    isResourcesLandingPageLoading: true,
  }, state),

  [actions.receiveResourcesLandingPageData]: (state, action) => u({
    isResourcesLandingPageLoading: false,
    resourcesLandingPageData: action.payload.data[0].attributes,
  }, state),

  [actions.fetchResourceStories]: (state, action) => u({
    isResourceStoriesLoading: true,
  }, state),

  [actions.receiveResourceStories]: (state, action) => u({
    isResourceStoriesLoading: false,
    resourceStories: action.payload.data,
  }, state),

  [actions.fetchResourceStoriesLanguages]: (state, action) => u({
    isResourceStoriesLanguagesLoading: true,
  }, state),

  [actions.receiveResourceStoriesLanguages]: (state, action) => u({
    isResourceStoriesLanguagesLoading: false,
    resourceStoriesLanguages: action.payload.data,
  }, state),

  [actions.fetchAllCampaignRegistrations]: (state, action) => u({
    isFetchingAllCampaignRegistrations: true,
  }, state),

  [actions.receiveAllCampaignRegistrations]: (state, action) => u({
    isFetchingAllCampaignRegistrations: false,
    allCampaignRegistrations: action.payload.data,
  }, state),

  [actions.fetchEventCertificateStaticData]: (state, action) => u({
    isFetchingECStaticData: true,
  }, state),

  [actions.receiveEventCertificateStaticData]: (state, action) => u({
    isFetchingECStaticData: false,
    eventCertificateStaticData: action.payload.data.length > 0 ? action.payload.data[0].attributes : null,
  }, state),

  [actions.fetchEventCertificateDetails] : (state, action) => u({
    isFetchingEventCertDetails: true,
  }, state),

  [actions.receiveEventCertificateDetails] : (state, action) => u({
    isFetchingEventCertDetails: false,
    isEventCertEnrolled: action.payload.ok,
    eventCertDetails: action.payload.data,
  }, state),

  [actions.fetchEventCertificateEnroll] : (state, action) => u({
    isEventCertEnrolling: true,
    showSuccessAnimation: false
  }, state),

  [actions.receiveEventCertificateEnroll] : (state, action) => u({
    isEventCertEnrolling: false,
    isEventCertEnrolled: true,
    showSuccessAnimation: true,
  }, state),

  [actions.fetchEventCertificate]: (state, action) => u({
    isEventCertDownloading: true,
  }, state),

  [actions.receiveEventCertificate]: (state, action) => u({
    isEventCertDownloading: false,
    eventCertUrl: action.payload.url
  }, state),

  [actions.fetchEventLangSupportData]: (state, action) => u({
    isFetchingLangSupportData: true,
  }, state),

  [actions.receiveEventLangSupportData]: (state, action) => u({
    isFetchingLangSupportData: false,
    eventLangSupportData: (action.payload.data.length > 0 && action.payload.data[0].attributes) ? action.payload.data[0].attributes.languageSupport : {},
  }, state),
}, initialState);



// WEBPACK FOOTER //
// ./src/redux/stemReducer.js